<div class="form-group">
    <label [for]="id" >{{title}} {{control | controlRequiredText}}</label>

    <input-text-area 
    [id]="id" 
    [title]="title"
    [maxlength]="maxlength" 
    [placeholder]="placeholder" 
    [rows]="rows" 
    [control]="control">
    </input-text-area>

    <div class="row">
        <div class="col-12 col-lg-8">
            <div-validation-message 
            [control]="control" 
            [messageRequired]="messageRequired" 
            ></div-validation-message>
        </div>
        <div class="col-12 col-lg-4">
            <small class="form-text text-right text-muted"><span></span>{{maxlength - control.value?.length}} &nbsp;caracteres disponibles</small>
        </div>
    </div>
</div>